import { Empty, Modal } from "antd";
import React from "react";
import CustomTable from "../../Component/Table";
import { getUsersRecommendations } from "../../Services/recommendation";
import { getUsersTravelRecommendations } from "../../Services/travel_recommendation";
import { useQuery } from "@tanstack/react-query";

const columns = [
  // {
  //   title: "Image",
  //   dataIndex: "full_image_url",
  //   key: "full_image_url",
  //   render: (image) => (
  //     <img
  //       src={image}
  //       alt="Recommendation"
  //       style={{ width: 50, height: 50, borderRadius: 5 }}
  //     />
  //   ),
  // },
  {
    title: "Preferences List",
    dataIndex: "name",
    key: "name",
  },
  // {
  //   title: "Description",
  //   dataIndex: "description",
  //   key: "description",
  // },
];
function ViewModal({ isModalVisible, handleCancel, initialValues, type }) {
  const { data, isLoading } = useQuery({
    queryKey: [`user-recommendations-${type}-${initialValues?.id}`],
    queryFn: () => type === 'preference'?
      getUsersRecommendations(initialValues?.id) : getUsersTravelRecommendations(initialValues?.id),
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    retry: false,
    enabled: !!initialValues?.id,
  });

  const sortedData = [...(data || [])].sort((a, b) =>
    a.name.localeCompare(b.name)
  );
  return (
    <div>
      <Modal
        title={`${initialValues?.name} ${type==='preference'? '': "Travel"} Preferences`}
        open={isModalVisible}
        footer={null}
        onCancel={() => {
          handleCancel();
        }}
      >
        {(sortedData?.length || isLoading) ? (
          <CustomTable
            columns={columns}
            data={sortedData}
            loading={isLoading}
            pagination={false}
          />
        ) : !isLoading ? (
          <Empty />
        ) : null}
      </Modal>
    </div>
  );
}

export default ViewModal;
